module.exports = "<div class=\"view-container\">\n    <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/view-container/view-container.component.html
// module id = ./src/app/components/view-container/view-container.component.html
// module chunks = main